var extendFlags,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

extendFlags = function() {
  var bodyClasses, ref, ref1;
  bodyClasses = document.body.classList || $(document.body).getClasses();
  return _.extend(window.Groupon, {
    App: {
      name: $(document.head).attr('data-app')
    },
    Browsers: {
      chrome: !!window.chrome,
      ltIE10: $('html').hasClass('lt-ie10'),
      phantomJS: !!(window._phantom || window.callPhantom),
      safari: ((ref = navigator.vendor) != null ? ref.indexOf('Apple') : void 0) > -1 && !((ref1 = navigator.userAgent) != null ? ref1.match('CriOS') : void 0)
    },
    PageFlags: {
      isWeb: indexOf.call(bodyClasses, 'is-web') >= 0,
      isTouch: indexOf.call(bodyClasses, 'is-touch') >= 0,
      isLegacyResponsive: indexOf.call(bodyClasses, 'ls-resp') >= 0,
      isTouchRedesign: indexOf.call(bodyClasses, 't-redesign') >= 0,
      isTouchRequest: indexOf.call(bodyClasses, 'is-touch-request') >= 0
    }
  });
};

module.exports = function() {
  if (document.body != null) {
    return extendFlags();
  } else {
    return $(function() {
      return extendFlags();
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvZ3JvdXBvbl9leHRlbmRlZC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9ncm91cG9uX2V4dGVuZGVkLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLFdBQUE7RUFBQTs7QUFBQSxXQUFBLEdBQWMsU0FBQTtBQUVaLE1BQUE7RUFBQSxXQUFBLEdBQWMsUUFBUSxDQUFDLElBQUksQ0FBQyxTQUFkLElBQTJCLENBQUEsQ0FBRSxRQUFRLENBQUMsSUFBWCxDQUFnQixDQUFDLFVBQWpCLENBQUE7U0FFekMsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxNQUFNLENBQUMsT0FBaEIsRUFBeUI7SUFDdkIsR0FBQSxFQUNFO01BQUEsSUFBQSxFQUFNLENBQUEsQ0FBRSxRQUFRLENBQUMsSUFBWCxDQUFnQixDQUFDLElBQWpCLENBQXNCLFVBQXRCLENBQU47S0FGcUI7SUFHdkIsUUFBQSxFQUNFO01BQUEsTUFBQSxFQUFRLENBQUMsQ0FBQyxNQUFNLENBQUMsTUFBakI7TUFDQSxNQUFBLEVBQVEsQ0FBQSxDQUFFLE1BQUYsQ0FBUyxDQUFDLFFBQVYsQ0FBbUIsU0FBbkIsQ0FEUjtNQUVBLFNBQUEsRUFBVyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsUUFBUCxJQUFtQixNQUFNLENBQUMsV0FBM0IsQ0FGYjtNQUdBLE1BQUEseUNBQXdCLENBQUUsT0FBbEIsQ0FBMEIsT0FBMUIsV0FBQSxHQUFxQyxDQUFDLENBQXRDLElBQTRDLDZDQUF1QixDQUFFLEtBQXJCLENBQTJCLE9BQTNCLFdBSHhEO0tBSnFCO0lBUXZCLFNBQUEsRUFDRTtNQUFBLEtBQUEsRUFBTyxhQUFZLFdBQVosRUFBQSxRQUFBLE1BQVA7TUFDQSxPQUFBLEVBQVMsYUFBYyxXQUFkLEVBQUEsVUFBQSxNQURUO01BRUEsa0JBQUEsRUFBb0IsYUFBYSxXQUFiLEVBQUEsU0FBQSxNQUZwQjtNQUdBLGVBQUEsRUFBaUIsYUFBZ0IsV0FBaEIsRUFBQSxZQUFBLE1BSGpCO01BSUEsY0FBQSxFQUFnQixhQUFzQixXQUF0QixFQUFBLGtCQUFBLE1BSmhCO0tBVHFCO0dBQXpCO0FBSlk7O0FBb0JkLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFNBQUE7RUFDZixJQUFHLHFCQUFIO1dBQ0UsV0FBQSxDQUFBLEVBREY7R0FBQSxNQUFBO1dBR0UsQ0FBQSxDQUFFLFNBQUE7YUFBRyxXQUFBLENBQUE7SUFBSCxDQUFGLEVBSEY7O0FBRGUifQ==
